import { createAsyncThunk } from "@reduxjs/toolkit";
import { controlledVocabularies } from "../../../API/ControlledVocabularies";

const getAllUnits = createAsyncThunk(
  "controlledVocabularies/getAllUnits",
  async () => {
    try {
      const data = await controlledVocabularies.getManyUnitOfMeasurement()
      return data;
    } catch (err) {
      console.log("error");
      ;
    }
  }
);

export { getAllUnits };